module.exports = __webpack_public_path__ + "img/Bg.4011ac2c.png";